import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Popconfirm, Row } from "antd";
import { PlusCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import { FileOutlined } from "@ant-design/icons";
//Ducks
import * as ducks from "../../../../redux/aspirante/expDigitalDucks";
//Utils
import { blobToFile, INFO_ELIMINAR } from "../../../../utils";

/**
 * Componente que muestra la lista de documentos a subir por el aspirante a su expediente digital.
 * @return {JSX.Element}
 * @author Uriel Carrión
 */
export const ListaArchivoSubir = () => {
  const dispatch = useDispatch();
  const { listaArchivosPorSubir, catDocsPendientes } = useSelector(
    (state) => state.expDigital
  );

  /**
   * Función que permite guardar en el documento del aspirante en la BD.
   * @param {object} documento
   */
  const guardar = (documento) => {
    let formData = new FormData();
    Object.entries(documento).forEach(([key, value]) => {
      if (`${key}` === "archivo") {
        //Se realiza la creación de un new File ya que al iterarlo por defecto lo obtiene como string
        const file = blobToFile(value);
        //Se manda el archivo en la lista
        formData.append(`${key}`, file);
      } else {
        formData.append(`${key}`, value);
      }
    });
    //Se manda a guardar
    dispatch(ducks.saveExpediente(formData));
    //Se quita el documento de la lista
    dispatch(ducks.eliminarDocumento(documento.idTipoDocumento)); //Se elimina de la lista
  };

  /**
   * Función que elimina el documento del aspirante
   * @param {number} idDocumento
   */
  const eliminar = (idDocumento) => {
    dispatch(ducks.eliminarDocumento(idDocumento)); //Se elimina de la lista
    const tipoDocumento = getTipoDocumento(idDocumento); //Se busca el tipo de documento en una copia de tipos de documentos
    dispatch(ducks.setTipoDocumento(tipoDocumento)); //Se vuelve agregar a la lista original
  };

  /**
   * Función que busca un tipo de documento
   * @param {number} id
   * @return {object} El tipodocumento
   */
  const getTipoDocumento = (id) =>
    catDocsPendientes.find(({ idDocumento }) => idDocumento === id);

  return (
    <div style={{ overflowY: "auto", overflowX: "hidden" }}>
      {listaArchivosPorSubir.map((item, i) => (
        <div className="cargar-archivo" key={i}>
          <Row gutter={24}>
            <Col span={12} xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
              <FileOutlined /> {item.archivo.name}
            </Col>
            <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
              <Button
                type="ghost"
                className="btn-cargar-archivo"
                icon={<PlusCircleOutlined />}
                onClick={() => {
                  guardar(item);
                }}
              >
                Agregar al listado
              </Button>
            </Col>
            <Col span={4} xxl={4} xl={4} lg={4} md={4} sm={24} xs={24}>
              <Popconfirm
                title={INFO_ELIMINAR}
                onConfirm={() => eliminar(item.idTipoDocumento)}
                okText="Aceptar"
                cancelText="Cancelar"
              >
                <Button
                  id="bntCircle"
                  shape="circle"
                  icon={<DeleteOutlined />}
                  style={{ marginTop: 0 }}
                />
              </Popconfirm>
            </Col>
          </Row>
        </div>
      ))}
    </div>
  );
};
